import { render } from "./AppFooter.vue?vue&type=template&id=43b23b38"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__